import { useState } from 'react';
import { AppBar, Box, Toolbar, Typography } from '@mui/material';
import { CasIconButton } from 'src/compass/shared/components';
import { useStopImpersonating } from '../../hooks/useImpersonation';

type ImpersonateUserAppBarProps = {
  impersonatingUserName: string;
};

export default function ImpersonateUserAppBar({
  impersonatingUserName,
}: ImpersonateUserAppBarProps) {
  const { stopImpersonating } = useStopImpersonating();
  const [isToolbarAtBottom, setIsToolbarAtBottom] = useState(true);

  const toggleToolbarPosition = () => setIsToolbarAtBottom((prev) => !prev);

  return (
    <AppBar
      position="fixed"
      color="primary"
      sx={{
        ...(isToolbarAtBottom && {
          top: 'auto',
          bottom: 0,
        }),
        zIndex: (theme) => theme.zIndex.modal + 1,
      }}
    >
      <Toolbar variant="dense" sx={{ justifyContent: 'space-between' }}>
        {/* Clear of the open-in-new-tab button that sits over the bar's left end. */}
        <Box sx={{ ml: '25px' }}>
          <CasIconButton icon="iconamoon:swap-fill" onClick={toggleToolbarPosition} />
        </Box>
        <Typography variant="h4">Impersonating {impersonatingUserName}</Typography>
        <CasIconButton icon="vaadin:close" onClick={stopImpersonating} />
      </Toolbar>
    </AppBar>
  );
}
